import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

const containedIconComponentStyle1 = css`
  display: inline-block;
  color: ${theme.colors.black};
  background: transparent;
  & svg {
    width: 100%;
    height: 100%;
  }
`;

const containedIconIconStyle2 = css`
  & svg {
    width: 100%;
    height: 100%;
  }
`;

export const IconContainerStyles = {
  containedIconComponentStyle1,
  containedIconIconStyle2,
};
